import CKEditor from 'ckeditor4-react';
import cx from 'classnames';
import * as _ from 'lodash';
import * as moment from 'moment';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-datepicker/dist/react-datepicker.css';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { DialogBox } from '../../../common/dialogbox';
import { utilService } from '../../../common/utils';
import { config } from '../../../config/config';
import * as adminActions from '../../../store/admin';
import * as portalActions from '../../../store/portal';

class ConnectionPdfs extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.actionsPDFButtonFormatter = this.actionsPDFButtonFormatter.bind(this);
    this.editEmailTemplate = this.editEmailTemplate.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.handelSelectChange = this.handelSelectChange.bind(this);

    this.state = {
      pdfs: [],
      pdfEmailText: {},
      subscribers: [
        {
          value: 'all_subscribers',
          label: 'All',
        },
      ],
      modal_data: {
        show: false,
      },
      errors: {},
      generatingPDF: false,
      editEmailTemplate: false,
      created_pdf_obj: null,
      downloading_pdf: false,
      isLoading: false,
      isSaving: false,
      pdfGenerating: false,
      sendingEmails: false
    };
  }

  componentDidMount() {
    // console.log(this.props.subscribedUsers);
    if (this.props.subscribedUsers.length > 0) {
      let subscribers = [
        {
          value: 'all_subscribers',
          label: 'All',
        },
      ];

      this.props.subscribedUsers.forEach((item, index) => {
        subscribers.push({
          value: item.email,
          label: item.email,
        });
      });
      
      this.setState({
        ...this.state,
        subscribers: subscribers
      })

    }
    // Fetch created pdfs
    this.props.getPdfs({
      token: this.props.token,
      params: '',
    });

    // fetch connection pdf email text

    let url = config.api_url + config.url.connection_pdf_emailtext;
    let request_json = {
      method: 'GET',
      headers: {
        Authorization: this.props.token,
        'Content-Type': 'application/json',
      },
    };
    fetch(url, request_json)
      .then(utilService.handleResponse)
      .then((result) => {
        
        let pdf_email_text = {};
        if (result.responceObject && result.responceObject.records.length) {
          pdf_email_text = result.responceObject.records[0];
        }
        if (this.state.subscribers.length > 0) {
          let thisObj = this;
          setTimeout(function () {
            
            thisObj.update_subscribers(pdf_email_text);
          }, 2000);
        }
        this.setState({
          ...this.state,
          pdfEmailText: pdf_email_text,
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  }

  update_subscribers(data) {
    let send_to = [];
    data.send_to.forEach((item, index) => {
      
      if (_.find(this.state.subscribers, { value: item.value })) {
        send_to.push(item);
      }
    });
    data.send_to = send_to;
    this.setState({
      ...this.state,
      pdfEmailText: data,
    });
  }

  /**
   * Handel close event of popup model
   */
  handleCloseModal() {
    this.setState({
      ...this.state,
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
    });
  }

  handelSelectChange(selectedOption) {
    let updateSelectedOption = selectedOption;
    if (_.find(selectedOption, { value: 'all_subscribers' })) {
      updateSelectedOption = [
        {
          value: 'all_subscribers',
          label: 'All',
        },
      ];
    }
    this.setState({
      ...this.state,
      pdfEmailText: {
        ...this.state.pdfEmailText,
        send_to: updateSelectedOption,
      },
    });
  }

  /**
   * Handel input change event
   * @param {*} dict Dictionary name
   * @param {*} e Form event
   */
  handleInputChange(dict, e) {
    const { name, value } = e.target;
    // console.log(name, value)
    let fields = this.state[dict];
    fields[name] = value;
    this.setState({
      fields,
    });
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps Getting previous props
   * @param {*} prevState Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    let thisObj = this;

    if (prevProps.pdfActionLoading && !this.props.pdfActionLoading) {
      // Show success delete notification when deleted successfully
      if (prevState.isDeleating) {
        this.setState(
          {
            ...this.state,
            errors: {},
            isLoading: false,
            isSaving: false,
            isDeleating: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Deleted successfully.'
            );
          }
        );
      }
    }

    // Get pdf status after generating pdf
    if (!_.isEqual(prevProps.pdf, this.props.pdf)) {
      if (this.props.pdf.status === 'Generating' && !this.props.pdf.error) {
        this.setState(
          {
            ...this.state,
            created_pdf_obj: this.props.pdf,
            generatingPDF: true,
          },
          function () {
            thisObj.props.getPdfStatus({
              token: this.props.token,
              id: this.props.pdf.connections_pdfUid,
              params: '',
            });
          }
        );
      } else {
        // console.log(this.props.pdf);

        this.setState({
          ...this.state,
          created_pdf_obj: null,
          generatingPDF: false,
          pdfGenerating: false
        });

        if (prevState.downloading_pdf) {
          if (this.props.pdf['url']) {
            this.downloadPDF(this.props.pdf['url']);
          }
          this.setState({
            downloading_pdf: false,
          });
        }
      }
    } else {
      
      if (
        this.state.created_pdf_obj &&
        this.state.created_pdf_obj.hasOwnProperty('connections_pdfUid') &&
        this.state.created_pdf_obj['connections_pdfUid'] ===
          this.props.pdf['connections_pdfUid']
      ) {
        
        if (_.isEqual(this.state.created_pdf_obj, this.props.pdf)) {
          setTimeout(function () {
            thisObj.props.getPdfStatus({
              token: thisObj.props.token,
              id: thisObj.props.pdf.connections_pdfUid,
              params: '',
            });
          }, 2000);
        }
      }
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    
    if (!_.isEqual(this.props.subscribedUsers, nextProps.subscribedUsers)) {
      let subscribers = [
        {
          value: 'all_subscribers',
          label: 'All',
        },
      ];
      if (nextProps.subscribedUsers.length) {
        nextProps.subscribedUsers.forEach((item, index) => {
          subscribers.push({
            value: item.email,
            label: item.email,
          });
        });
        this.setState(
          {
            ...this.state,
            subscribers: subscribers,
          },
          function () {
            if (
              this.state.pdfEmailText.hasOwnProperty('send_to') &&
              this.state.pdfEmailText.send_to.length > 0
            ) {
              
              this.update_subscribers(this.state.pdfEmailText);
            }
          }
        );
      }else{
        this.setState(
          {
            ...this.state,
            subscribers: subscribers,
          },
          function () {
            if (
              this.state.pdfEmailText.hasOwnProperty('send_to') &&
              this.state.pdfEmailText.send_to.length > 0
            ) {
              
              this.update_subscribers(this.state.pdfEmailText);
            }
          }
        );
      } 
    }
  }

  /**
   * Download the pdf when click on download button
   * @param {*} pdfURL Presigned url of pdf
   */
  downloadPDF(pdfURL) {
    const anchor = document.createElement('a');
    anchor.setAttribute('href', pdfURL);
    anchor.setAttribute('download', true);
    anchor.click();
    anchor.remove();
  }

  editEmailTemplate() {
    this.setState({
      ...this.state,
      editEmailTemplate: true,
    });
  }

  onEditorChange(e) {
    let fields = this.state.pdfEmailText;
    fields['email_html'] = e.editor.getData();
    this.setState({
      fields,
    });
  }

  validEmailTextForm() {
    let fields = this.state.pdfEmailText;
    let errors = {};
    let formIsValid = true;

    if (!fields['subject']) {
      formIsValid = false;
      errors['subject'] = '*Please enter subject.';
    }
    if (!fields['email_html']) {
      formIsValid = false;
      errors['email_html'] = '*Please enter email text.';
    }
    if (!fields['send_to']) {
      formIsValid = false;
      errors['send_to'] = '*Please select email.';
    }
    if (fields['send_to']) {
      if (fields['send_to'].length == 0) {
        formIsValid = false;
        errors['send_to'] = '*Please select email.';
      }
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  /**
   * Get presigned url of pdf when click on download pdf
   * @param {*} cell
   * @param {*} row
   * @param {*} rowIndex
   */
  onDownloadPdf(cell, row, rowIndex) {
    if (row.connections_pdfUid) {
      this.setState({
        downloading_pdf: true,
      });
      this.props.getPdfStatus({
        token: this.props.token,
        id: row.connections_pdfUid,
        params: '?generate_pdf_signed_url=yes',
      });
    }
  }

  /**
   * Open popup dialog when click on delete pdf button
   * @param {*} cell
   * @param {*} row
   * @param {*} rowIndex
   */
  onDeletePdf(cell, row, rowIndex) {
    if (row.connections_pdfUid) {
      this.setState({
        ...this.state,
        deleteModel: 'pdf',
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: 'Delete PDF',
            body: 'Are you sure you want to permanetly remove this pdf ?',
            rowId: row.connections_pdfUid,
          },
        },
      });
    }
  }

  /**
   * Handel submit event of popup model and call delete api
   * @param {*} id
   */
  OnDialogSubmit(id) {
    this.setState(
      {
        ...this.state,
        modal_data: {
          ...this.state.modal_data,
          show: false,
        },
        isLoading: true,
        isDeleating: true,
      },
      function () {
        this.props.deletePdf({
          id: id,
          token: this.props.token,
        });
      }
    );
  }

  sendEmail(cell, row, rowIndex) {
    if (row.connections_pdfUid) {
      let send_to_emails = [];

      if (
        this.state.pdfEmailText.send_to &&
        this.state.pdfEmailText.send_to.length > 0
      ) {
        this.state.pdfEmailText.send_to.forEach((item, index) => {
          send_to_emails.push(item.value);
        });
      }
      if (send_to_emails.length > 0) {
        let send_email_json = {
          send_to: send_to_emails,
          subject: this.state.pdfEmailText.subject,
          email_html: this.state.pdfEmailText.email_html,
          connections_pdfUid: row.connections_pdfUid,
          connections_pdf_title: row.title,
          connection_pdf_emailtextUid: this.state.pdfEmailText
            .connection_pdf_emailtextUid,
        };
        this.setState({
          sendingEmails: true
        })
        // console.log(send_email_json);
        let url = config.api_url + config.url.send_connection_pdf_email;
        let request_json = {
          method: 'POST',
          headers: {
            Authorization: this.props.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(send_email_json),
        };
        fetch(url, request_json)
          .then(utilService.handleResponse)
          .then((result) => {

            // After sending email fetch pdfs
            this.props.getPdfs({
              token: this.props.token,
              params: '',
            });

            this.setState({
              sendingEmails: false
            })
            
            if (result.responceObject && result.responceObject.userMessage) {
              if (result.responceObject.userMessage === '[SUCCESS] Email sent successfully') {
                NotificationManager.success(
                  'Success',
                  'Email sent successfully'
                );
              }
            }
          })
          .catch((error) => {
            // console.log(error);
            if (error.status && error.status == 400) {
              NotificationManager.error(error.message);
            }
          });
      } else {
        NotificationManager.error(
          'Error',
          'Please select atleast one subscriber email id to send email'
        );
      }
    }
  }

  /**
   * Show action button on pdf table
   * @param {*} cell
   * @param {*} row
   * @param {*} enumObject
   * @param {*} rowIndex
   */
  actionsPDFButtonFormatter(cell, row, enumObject, rowIndex) {
    return (
      <div className="d-flex align-items-center nav-con">
        {row.status === 'Completed' && (
          <button
            type="button"
            title="Download"
            className="btn btn-dark lh-0 p-3"
            onClick={this.onDownloadPdf.bind(this, cell, row, rowIndex)}
          >
            <i className="fa fa-download fa-w-16" aria-hidden="true" />
          </button>
        )}
        {row.status === 'Completed' && !row.emailed && (
          <button
            type="button"
            title="Send Email"
            className="btn btn-dark lh-0 p-3"
            onClick={this.sendEmail.bind(this, cell, row, rowIndex)}
          >          
            <i className="fa fa-envelope fa-w-16" aria-hidden="true" />                      
          </button>
        )}
        {(row.status === 'Completed' || row.error) && (
          <button
            type="button"
            title="Delete"
            className="btn btn-primary lh-0 p-3"
            onClick={this.onDeletePdf.bind(this, cell, row, rowIndex)}
          >
            <i className="fa fa-trash fa-w-16" aria-hidden="true" />
          </button>
        )}
      </div>
    );
  }

  /**
   * Generate pdf when click on pdf button
   */
  initGeneratePDF() {
    this.setState({
      pdfGenerating: true
    })
    this.props.generatePDF({
      token: this.props.token,
    });
  }

  onSaveEmailText(e) {
    e.preventDefault();
    if (this.validEmailTextForm()) {
      // Save connection pdf email text

      let url = config.api_url + config.url.connection_pdf_emailtext;
      let request_json = {
        method: 'POST',
        headers: {
          Authorization: this.props.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.state.pdfEmailText),
      };
      this.setState({
        isSaving: true,
      });
      fetch(url, request_json)
        .then(utilService.handleResponse)
        .then((result) => {
          // console.log(result);
          this.setState({
            isSaving: false,
            editEmailTemplate: false,
          });
          if (
            result.responceObject &&
            result.responceObject.records.schoolUid
          ) {
            NotificationManager.success('Success', 'Saved successfully');
          }
        })
        .catch((error) => {
          if (error.status === 401) {
            window.location.reload();
          }
        });
    }
  }

  

  render() {
    const { pdfs } = this.props;

    const pdf_columns = [
      {
        dataField: 'created_at',
        text: 'Created At',
        sort: true,
        formatter: dateFormatter,
      },
      {
        dataField: 'title',
        text: 'Title',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: '200px', textAlign: 'left' };
        },
      },
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
      },
      {
        dataField: 'error',
        text: 'Error',
        sort: true,
      },
      {
        dataField: 'emailed',
        text: 'Emailed',
        sort: true,
        formatter: dateFormatter,
      },
      {
        dataField: 'button',
        text: 'Actions',
        formatter: this.actionsPDFButtonFormatter,
      },
    ];

    const pdfDefaultSorted = [
      {
        dataField: 'created_at',
        order: 'desc',
      },
    ];

    const pdfsList = pdfs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="connections_pdfUid"
          data={pdfs}
          loading={true}
          columns={pdf_columns}
          defaultSorted={pdfDefaultSorted}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    return (
      <>
        {/* {this.props.pdfActionLoading === true && (
          <utilService.GridSweetLoader loading={this.props.pdfActionLoading} />
        )} */}
        <div className="border-bottom border-dashed h3 pb-3 mb-5 d-flex align-items-center">
          <span>Connections PDF</span>
          <div className="d-flex align-items-center ml-auto flex-shrink-0">
            <button
              type="button"
              className="btn btn-icon btn-pear p-0 d-flex align-items-center mr-3"
              onClick={this.initGeneratePDF.bind(this)}
              disabled={this.props.pdfActionLoading}
              title="Generate PDF"
            >
              <span className="pl-3">Generate PDF</span>
              <i
                className={cx(
                  'fa fa-file-pdf-o flex-shrink-0 h3 lh-1 md-display-6 p-3',
                  {
                    'd-none': this.state.pdfGenerating,
                  }
                )}
              />
              <span
                className={cx('p-3', {
                  'd-none': !this.state.pdfGenerating,
                })}
              >
                <utilService.BorderSpinner
                  loading={this.state.pdfGenerating}
                  color="pear"
                  size={1.5}
                />
              </span>
            </button>
            <button
              type="button"
              className="btn btn-blue-lagoon btn-icon font-weight-600 px-6 py-4 text-uppercase"
              onClick={this.editEmailTemplate}
            >
              Edit Email template
            </button>
          </div>
        </div>
        {this.state.editEmailTemplate && (
          <Form className="mb-3">
            <Row lg={2} xs={1}>
              <Col>
                <Form.Group controlId="sendToEmail">
                  <Form.Label className="title-label">Send To</Form.Label>
                  <Select
                    value={this.state.pdfEmailText.send_to}
                    isMulti
                    onChange={this.handelSelectChange}
                    options={this.state.subscribers}
                  />
                  <div className="errorMsg">{this.state.errors['send_to']}</div>
                  {/* <Form.Control
                  as="textarea"
                  name="send_to"
                  onChange={this.handleInputChange.bind(this, 'pdfEmailText')}
                  value={this.state.pdfEmailText.send_to || ''}
                /> */}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="emailSubject">
                  <Form.Label className="title-label">Subject</Form.Label>
                  <Form.Control
                    name="subject"
                    className="w-100"
                    onChange={this.handleInputChange.bind(this, 'pdfEmailText')}
                    value={this.state.pdfEmailText.subject || ''}
                  />
                  <div className="errorMsg">{this.state.errors['subject']}</div>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="emailBody" className="mb-3">
              <Form.Label className="title-label">Email Text</Form.Label>
              <CKEditor
                onBeforeLoad={(CKEDITOR) => {
                  CKEDITOR.disableAutoInline = true;
                  CKEDITOR.addCss(
                    'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                  );
                }}
                config={{
                  versionCheck: false,
                  stylesSet: [
                    // Block-level styles.
                    {
                      name: 'Content title',
                      element: 'h1',
                      styles: {
                        color: '#C41425',
                        'font-family': 'Open Sans Semibold',
                        'line-height': '135%',
                      },
                    },
                    {
                      name: 'Content Info',
                      element: 'p',
                      styles: {
                        color: '#586667',
                        padding: '0px !important',
                        'font-family': 'Open Sans Light',
                        'font-size': '14px',
                      },
                    },
                    // Inline styles.
                    {
                      name: 'Text Gray',
                      element: 'p',
                      styles: {
                        color: '#AAA !important',
                        'font-family': 'Open Sans Light',
                        'font-size': '16px',
                      },
                    },
                    {
                      name: 'Anchor Red',
                      element: 'a',
                      styles: {
                        color: '#C41425 !important',
                        'text-decoration': 'none',
                      },
                    },
                  ],
                  format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
                }}
                onChange={this.onEditorChange}
                data={this.state.pdfEmailText.email_html || ''}
              />
              <div className="errorMsg">{this.state.errors['email_html']}</div>
            </Form.Group>

            <div className="text-right">
              <button
                onClick={(e) => this.onSaveEmailText(e)}
                disabled={this.state.isSaving}
                className="btn btn-primary font-weight-600 px-6 py-3 text-uppercase"
              >
                {this.state.isSaving ? 'Save...' : 'Save'}
              </button>
            </div>
          </Form>
        )}        
        {pdfsList}
        {this.state.sendingEmails  && (
          <utilService.GridSweetLoader
            loading={this.state.sendingEmails}
          />
        )}
        <DialogBox
          show_modal={this.state.modal_data}
          hide_modal={this.handleCloseModal.bind(this)}
          onSubmit={this.OnDialogSubmit.bind(this)}
        />
        <div className="overlay"></div>
      </>
    );
  }
}

/**
 * Formate date before displaying in table
 * @param {*} cell
 * @param {*} row
 */
function dateFormatter(cell, row) {
  if (cell) {
    return moment(cell).format('YYYY-MM-DD hh:mm a');
  } else {
    return '';
  }
}

/**
 * Print no records found when data empty
 */
function indication() {
  return 'No records found!';
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  // console.log('state....', state);
  return {
    pdfActionLoading: state.subscribedUsers.pdf.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    pdf: state.subscribedUsers.pdf.pdfObj,
    pdfs: Object.values(state.subscribedUsers.pdf.byId),
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, adminActions, portalActions), dispatch)
)(ConnectionPdfs);
